import { formErrorTypes } from '../../../types/api-response';
import { createSlice } from "@reduxjs/toolkit";

export const initialState: formErrorTypes = {
    title: false,
    skillList: false,
    minExperience: false,
    maxExperience: false,
    description: false,
    locationList: false,
    roleList: false,
    ownerName: false,
    industryList: false,
    ownerEmail: false,
    aboutCompany: false,
    companyName: false,
    minSalary: false,
    maxSalary: false,
    jobType: false,
    contractJobBillingDuration: false,
    contractJobContractTenure: false,
    ownerPhone: false,
    ownerDesignation: false,
    companyProfile: false,
    mapToExistingFolderId: false,
    currencyId: false,
    folderInput:false,
    venueAddress:false
}

const errorFormSlice = createSlice({
    name: "formErrors",
    initialState,
    reducers: {
        updateErrors: (state, action) => {
            const errorFields = action.payload;
            return {
                ...state, ...Object.fromEntries(errorFields.map((field: string) => [field, true]))
            }
        },
        resetError: (state, action) => {
            const field = action.payload
            return {
                ...state, [field]: false
            }
        },
        resetAllErrors: () => {
            return initialState
        }
    },
});

export const { updateErrors, resetError, resetAllErrors } = errorFormSlice.actions;
export default errorFormSlice;
